import React, { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { usePrimaryPropertyId } from "../hooks/useMyProperties";
import { useQuery } from "@tanstack/react-query";
import api from "../lib/api";
import { SectionHeading } from "../components/Loader";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { fmtDate } from "../lib/format";
import { toast } from "sonner";

export default function Account() {
  const { user, refresh } = useAuth();
  const { propertyId } = usePrimaryPropertyId();
  const { data: prop } = useQuery({ queryKey: ["property", propertyId], queryFn: async () => (await api.get(`/properties/${propertyId}`)).data, enabled: !!propertyId });
  const [busy, setBusy] = useState(false);

  const sendReset = async () => {
    setBusy(true);
    try { await api.post("/auth/forgot-password", { email: user.email }); toast.success("Password reset link sent to your email."); }
    catch { toast.error("Could not send reset link."); }
    finally { setBusy(false); }
  };

  return (
    <div className="space-y-6 arq-fade-up max-w-2xl">
      <SectionHeading overline="Account" title="Your Account" />
      <div className="bg-arq-card border border-border rounded-md p-6 space-y-4">
        <div className="grid sm:grid-cols-2 gap-4">
          <div><Label>Name</Label><Input value={user?.name || ""} disabled className="mt-1.5" /></div>
          <div><Label>Email</Label><Input value={user?.email || ""} disabled className="mt-1.5" /></div>
          <div><Label>Phone</Label><Input value={user?.phone || "—"} disabled className="mt-1.5" /></div>
          <div><Label>Role</Label><Input value={user?.role} disabled className="mt-1.5 capitalize" /></div>
        </div>
        <div className="pt-2">
          <Button variant="outline" onClick={sendReset} disabled={busy} data-testid="reset-password-btn">Reset password</Button>
        </div>
      </div>

      {prop && (
        <div className="bg-arq-card border border-border rounded-md p-6">
          <h2 className="font-display text-xl mb-4">Your Home</h2>
          <div className="grid sm:grid-cols-2 gap-4 text-sm">
            <div><p className="text-xs uppercase tracking-wider text-muted-foreground">Address</p><p className="text-arq-ink">{prop.address}</p></div>
            <div><p className="text-xs uppercase tracking-wider text-muted-foreground">Residence</p><p className="text-arq-ink font-mono">#{prop.residence_id}</p></div>
            <div><p className="text-xs uppercase tracking-wider text-muted-foreground">Builder</p><p className="text-arq-ink">{prop.builder}</p></div>
            <div><p className="text-xs uppercase tracking-wider text-muted-foreground">Project Manager</p><p className="text-arq-ink">{prop.project_manager}</p></div>
            <div><p className="text-xs uppercase tracking-wider text-muted-foreground">Estimated Completion</p><p className="text-arq-ink">{fmtDate(prop.estimated_completion)}</p></div>
            <div><p className="text-xs uppercase tracking-wider text-muted-foreground">Co-owners</p><p className="text-arq-ink">{(prop.homeowners || []).map((h) => h.name).join(", ")}</p></div>
          </div>
        </div>
      )}
    </div>
  );
}
